import script from "./RefundEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundEdit.vue?vue&type=script&setup=true&lang=js"

import "./RefundEdit.vue?vue&type=style&index=0&id=95b454c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95b454c8"]])

export default __exports__